export function getSolveColumns() {
    return [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            editable: false,
        },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            editable: false,
        },
        {
            field: "puzzleTitle",
            headerName: "Puzzle",
            flex: 1.2,
            editable: false,
        },
        {
            field: "gridSize",
            headerName: "Grid",
            flex: 0.6,
            editable: false,
            valueFormatter: (value) => (value ? `${value}×${value}` : ""),
        },
        {
            field: "difficulty",
            headerName: "Level",
            flex: 0.7,
            editable: false,
        },
        {
            field: "tileMode",
            headerName: "Mode",
            flex: 0.7,
            editable: false,
            valueFormatter: (value) => {
                if (value === "numbers") return "Numbers";
                if (value === "image") return "Image";
                return "";
            },
        },
        {
            field: "startedAt",
            headerName: "Started",
            flex: 1,
            editable: false,
        },
        {
            field: "finishedAt",
            headerName: "Finished",
            flex: 1,
            editable: false,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 0.9,
            editable: false,
        },
        {
            field: "attemptsCount",
            headerName: "Attempts",
            flex: 0.8,
            editable: false,
            type: "number",
        },
    ];
}
